// Inline-SVG icons for share-web. No icon-font dependency (the player uses
// web-components + CSS glyphs; library/empty-state needs crisp stroked icons).
// Each icon scales to the parent font-size (width/height 1em) and inherits
// color via currentColor — DS-token-able by setting `color` on the parent.

const PATHS: Record<string, string> = {
  eye: '<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"/><circle cx="12" cy="12" r="3"/>',
  musicOff: '<path d="M9 18V6l10-2v10"/><circle cx="6" cy="18" r="3"/><circle cx="16" cy="16" r="3"/><line x1="3" y1="3" x2="21" y2="21"/>',
  music: '<path d="M9 18V6l10-2v10"/><circle cx="6" cy="18" r="3"/><circle cx="16" cy="16" r="3"/>',
  words: '<path d="M4 6h16"/><path d="M4 11h16"/><path d="M4 16h9"/>',
  arrowLeft: '<line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>',
  search: '<circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>',
  chevronDown: '<polyline points="6 9 12 15 18 9"/>',
  chevronRight: '<polyline points="9 18 15 12 9 6"/>',
  chevronLeft: '<polyline points="15 18 9 12 15 6"/>',
  alert: '<circle cx="12" cy="12" r="9"/><line x1="12" y1="8" x2="12" y2="13"/><line x1="12" y1="16" x2="12.01" y2="16"/>',
  users: '<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>',
  // Волна F: вход в лист владельца песни (прототип, `ICON.more`). Единственная
  // ЗАЛИТАЯ иконка в наборе: три точки — это точки, а не окружности, и обводкой
  // в 2px они превратились бы в кольца. Поэтому каждый круг гасит обводку и
  // берёт заливку явно, перекрывая `fill="none" stroke="currentColor"` обёртки.
  more: '<circle cx="5" cy="12" r="1.8" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="1.8" fill="currentColor" stroke="none"/><circle cx="19" cy="12" r="1.8" fill="currentColor" stroke="none"/>',
  // Единый сетлист, фаза 3: гостевой замок — слот аудио, закрытого для гостя
  // (song-row-controls.ts, is-locked), и центральный значок экрана «This link
  // is closed» (setlist-screen/guest-view.ts).
  lock: '<rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>',
};

export const ICON_NAMES = Object.keys(PATHS) as ReadonlyArray<keyof typeof PATHS>;
export type IconName = keyof typeof PATHS;

/** Returns an inline-SVG string. Safe to assign via innerHTML (constant markup). */
export function icon(name: IconName): string {
  return `<svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${PATHS[name]}</svg>`;
}
